import React from 'react';
import IndexView from 'views/IndexView';

const IndexPage = () => {
  return <IndexView />;
};

export default IndexPage;
